import * as types from '../actions/action-types';
import _ from 'lodash';


const initialState = {
    files: [],
    uploadData: {
        title: '',
        caption: '',
        privacy: 'ORGANIZATION_PRIVATE',
        selectedOrganization: 0,
        keywordsStr: '',
        keywords: [],
        attribution: '',
        attributionMode: 'NONE'
    }
};

const uploadsReducer = function(state = initialState, action) {

    let files = [...state.files];
    let newState;

    switch(action.type) {
        case types.ADD_UPLOADS:
            return Object.assign({}, state, { files: files.concat(action.files)});
        case types.DELETE_UPLOAD:
            _.remove(files, file => {
                return file.tempUUID === action.tempUUID;
            } );
            if (!files.length) {
                return Object.assign({}, initialState);
            }
            return Object.assign({}, state, { files});

        case types.CLEAR_UPLOADS:
            return Object.assign({}, initialState);

        case types.SET_UPLOAD_DATA:
            newState = Object.assign({}, state);
            newState.uploadData = Object.assign({}, state.uploadData, action.data);
            const keywordsStr = newState.uploadData.keywordsStr;
            if (keywordsStr && /\n$/.test(keywordsStr)) {
                const s = keywordsStr.slice(0, keywordsStr.length - 1);
                if (s && !newState.uploadData.keywords.includes(s)) {
                    newState.uploadData.keywords.push(s);
                }
                newState.uploadData.keywordsStr = '';
            }
            return newState;
        case types.DELETE_KEYWORD:
            newState = Object.assign({}, state);
            newState.uploadData = Object.assign({}, state.uploadData);
            newState.uploadData.keywords = _.filter(newState.uploadData.keywords, k => k !== action.keyword);
            return newState;

        default:
            return state;
    }

};

export default uploadsReducer;
